module.exports = __webpack_public_path__ + "img/shoot-2.96da3c4b.jpg";